import {prettifyNumber} from "@/tscript/utils/generalHelpers";
import {OF_STATUS} from "@oplit/shared-module";
import {OperationStatus} from "@/interfaces";

/**
 * for debit POs we consider that the components have been
 * consumed when the first operation started, whichever its date is
 */
function shouldConsiderComponentAsOk(operation: {
  op_status: OperationStatus;
  status_done_at?: string;
  status_ongoing_at?: string;
}): boolean {
  if (!operation) return false;
  if (operation.status_done_at) return true;
  if (operation.status_ongoing_at) return true;
  if (
    ([OF_STATUS.DONE, OF_STATUS.ON_GOING] as OperationStatus[]).includes(
      operation.op_status,
    )
  )
    return true;
  return false;
}

function formatQuantity(quantity: number): string {
  return prettifyNumber(quantity, "0,0.[000]");
}

export {shouldConsiderComponentAsOk, formatQuantity};
